import { render, staticRenderFns } from "./GradeDesc.vue?vue&type=template&id=5cac02da&scoped=true&"
import script from "./GradeDesc.vue?vue&type=script&lang=js&"
export * from "./GradeDesc.vue?vue&type=script&lang=js&"
import style0 from "./GradeDesc.vue?vue&type=style&index=0&id=5cac02da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac02da",
  null
  
)

export default component.exports